<template>
  <div id="modal-category-edit" uk-modal>
    <div class="uk-modal-dialog uk-modal-body">
      <h2 class="uk-modal-title">{{ $t('general.edit_categories') }}</h2>
      <div class="table-responsive">
        <table class="table align-items-center">
          <thead>
          <tr>
            <th scope="col">{{ $t('general.category_name') }}</th>
            <th scope="col"></th>
          </tr>
          </thead>
          <tbody class="list">
          <tr>
            <td>
              <input v-model="newCategory" :placeholder="$t('general.new_category_title')" type="text">
            </td>
            <td class="text-right">
              <div class="actions ml-3">
                <button class="btn btn-sm btn-secondary btn-icon-label uk-first-column"
                        @click="handleAddCategory">
                  <span class="btn-inner--icon"><i class="uil-plus"></i></span>
                  <span class="btn-inner--text">{{ $t('general.add') }}</span>
                </button>
              </div>
            </td>
          </tr>
          <tr v-for="(element, index) in categories" :key="index">
            <td>
              <input v-model="element.name" :placeholder="$t('general.new_category_title')" type="text">
            </td>
            <td class="text-right">
              <div class="actions actions-buttons ml-3 flex">
                <a class="btn btn-icon btn-hover btn-sm btn-circle " href="javascript:void(0)"
                   @click="handleSaveCategory(element, index)">
                  <i :class="{ 'text-success': savedUpdateIndex === index }" class="uil-check"/>
                </a>
                <a class="btn btn-icon btn-hover btn-sm btn-circle" href="javascript:void(0)"
                   @click="handleDeleteCategory(element, index)">
                  <i class="uil-trash text-danger"></i>
                </a>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <p class="uk-text-right">
        <button class="uk-button uk-button-default uk-modal-close mr-2" type="button">
          {{ $t("general.close") }}
        </button>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CategoryEditModal",
  props: {
    categories: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      newCategory: '',
      savedUpdateIndex: null
    }
  },
  methods: {
    show() {
      UIkit.modal("#modal-category-edit").show();
    },
    hide() {
      UIkit.modal("#modal-category-edit").hide();
    },
    handleAddCategory() {
      if (this.newCategory && this.newCategory.trim()) {
        this.$emit('add-category', this.newCategory.trim());
        this.newCategory = '';
      }
    },
    handleSaveCategory(element, index) {
      this.$emit('save-category', { element, index });
      this.savedUpdateIndex = index;
      setTimeout(() => {
        this.savedUpdateIndex = null;
      }, 2000);
    },
    handleDeleteCategory(element, index) {
      this.$emit('delete-category', { element, index });
    }
  }
}
</script>

<style scoped>
.actions-buttons {
  display: flex;
}

</style>

